import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { ServerAction } from '../server.action';

export const startServerProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    ServerAction.create.started,
    ServerAction.remove.started,
  ),
  mergeMap(() => {
    return [
      ServerAction.processing.started(),
    ];
  }),
);
